import { HiChatBubbleOvalLeft } from "react-icons/hi2";

export const ChatIcon = ({ width, height, color, ...props }) => (
  <HiChatBubbleOvalLeft
    size={width || height || 17}
    color={color || "currentColor"}
    {...props}
  />
);
